module.exports = "/assets/career/benefits/banner.png?qxaWhD/";